import React from 'react';
import { format } from 'date-fns';
import { getSymbol } from '../../utils/currency';
import { StatusBadge } from './_shared';

const BookingsView = ({ bookings }) => (
  <div className="bg-[#161b26] rounded-2xl border border-[#252d3d] overflow-hidden">
    <table className="w-full">
      <thead><tr className="border-b border-[#252d3d]">
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Booking</th>
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Listing</th>
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Buyer</th>
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Date</th>
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Amount</th>
        <th className="text-left py-3 px-4 text-[11px] font-semibold text-[#6b7a99] uppercase tracking-wider">Status</th>
      </tr></thead>
      <tbody>{bookings.map(b => (
        <tr key={b.booking_id} className="border-b border-[#252d3d]/50 hover:bg-[#1e2536]/50">
          <td className="py-2.5 px-4 text-xs font-mono text-[#6b7a99]">{b.booking_id?.slice(0, 16)}...</td>
          <td className="py-2.5 px-4 text-white text-sm font-medium">{b.listing_title}</td>
          <td className="py-2.5 px-4 text-[#a5b4d0] text-sm">{b.buyer_name}</td>
          <td className="py-2.5 px-4 text-[#6b7a99] text-xs">{b.start_date ? format(new Date(b.start_date), 'MMM d, yyyy') : '-'}</td>
          <td className="py-2.5 px-4 text-white text-sm font-medium">{getSymbol(b.currency || b.country)}{b.total_price}</td>
          <td className="py-2.5 px-4"><StatusBadge status={b.status} /></td>
        </tr>
      ))}</tbody>
    </table>
  </div>
);

export default BookingsView;
